export const TMS_BRAND_KEY = "tmsBrand";

export const TMS_BRAND = {
    SHIPEZ: "shipez",
    LOCKER_FREIGHT: "locker-freight",
    INFOX: "infox",
};

export const TMS_TITLES = {
    [TMS_BRAND.SHIPEZ]: "Info-X | Shipez.ai TMS",
    [TMS_BRAND.LOCKER_FREIGHT]: "Info-X | Locker Freight TMS",
    [TMS_BRAND.INFOX]: "Info-X | TMS",
};

export function getTitleForBrand(brand) {
    return TMS_TITLES[brand] || TMS_TITLES[TMS_BRAND.SHIPEZ];
}

export function getBrandFromPath(pathname = "") {
    if (pathname === "/locker-freight/login" || pathname.includes("locker-freight")) {
        return TMS_BRAND.LOCKER_FREIGHT;
    }
    if (pathname === "/infox/login" || pathname.includes("/infox/login")) {
        return TMS_BRAND.INFOX;
    }
    return TMS_BRAND.SHIPEZ;
}

export function persistTmsBrand(brand) {
    sessionStorage.setItem(TMS_BRAND_KEY, brand);
}

export function getPersistedTmsBrand() {
    return sessionStorage.getItem(TMS_BRAND_KEY) || TMS_BRAND.SHIPEZ;
}

export function applyTmsDocumentTitle(brand) {
    document.title = getTitleForBrand(brand);
}

export function clearTmsBrand() {
    sessionStorage.removeItem(TMS_BRAND_KEY);
}
